"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LMNTemplateEnumToJSON = exports.LMNTemplateEnumFromJSONTyped = exports.LMNTemplateEnumFromJSON = exports.LMNTemplateEnum = void 0;
/**
 * the template to use for generating LMNs
 * @export
 */
exports.LMNTemplateEnum = {
    Default: 'default',
    HereditaryCancer: 'hereditary_cancer',
    Nips: 'nips',
    Generic: 'generic',
    Pgx: 'pgx'
};
function LMNTemplateEnumFromJSON(json) {
    return LMNTemplateEnumFromJSONTyped(json, false);
}
exports.LMNTemplateEnumFromJSON = LMNTemplateEnumFromJSON;
function LMNTemplateEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.LMNTemplateEnumFromJSONTyped = LMNTemplateEnumFromJSONTyped;
function LMNTemplateEnumToJSON(value) {
    return value;
}
exports.LMNTemplateEnumToJSON = LMNTemplateEnumToJSON;
